import { render, staticRenderFns } from "./RadiogroupQuestion.vue?vue&type=template&id=46343613&"
import script from "./RadiogroupQuestion.vue?vue&type=script&lang=ts&"
export * from "./RadiogroupQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports